import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'displayDefaultZero'
})
export class DisplayDefaultZeroPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    if (value <= 0){
      return 0;
    }
    return value <= 9 ? 0 + `${value}` : `${value}`;
  }

}
